var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkout-minimal-container columns is-center" },
    [
      _vm.hasItems()
        ? [
            _vm._m(0),
            _vm._v(" "),
            _c("order-details", { ref: "orderDetails" }),
            _vm._v(" "),
            _c("offers"),
            _vm._v(" "),
            _c("item-list"),
            _vm._v(" "),
            _c("checkout-special-instructions"),
            _vm._v(" "),
            _c("BaseActions", { attrs: { actions: _vm.getCheckoutActions() } }),
            _vm._v(" "),
            _c("transition", { attrs: { name: "fade-down", mode: "out-in" } }, [
              _vm.showRecieptDetails
                ? _c(
                    "div",
                    [
                      _c("receipt-info", {
                        attrs: { totals: _vm.totalsForCheckout() }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center-message" }, [
      _c("p", [_vm._v("How does everything look?")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-159888c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-159888c0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/CheckoutView/CheckoutMinimal.vue
// module id = null
// module chunks = 